<template>
  <!-- document dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-image-outline</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertPhoto.addEditPhoto'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertPhoto.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <warnningComponent
          v-bind:textInfo.sync="textWarning"
          v-bind:typestatus.sync="typeWarning"
          v-bind:alert.sync="showWarnnig"
        ></warnningComponent>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="6" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.photoName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.photoName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.detail'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.detail'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.detail'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.photoFile'
                  )
                }}
                <span class="red--text">*</span>
                <span class="subtitle-1">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.photoFileInstruction'
                  )
                }}</span>
              </p>
              <div class="upload-btn-wrapper mt-2">
                <button class="btn-choose body-1 font-weight-medium">
                  <v-icon>mdi-upload</v-icon
                  >{{
                    this.$vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertPhoto.chooseBtn'
                    )
                  }}
                </button>
                <input
                  type="file"
                  name="myfile"
                  @change="onFileChange"
                  accept="iimage/x-png, image/jpeg"
                  multiple
                  counter
                />
              </div>
            </v-col>
          </v-row>
          <v-card elevation="0" outlined class="pa-5">
            <v-row>
              <draggable
                :list="list"
                :disabled="!enabled"
                class="list-group d-flex child-flex"
                ghost-class="ghost"
                :move="checkMove"
                @start="dragging = true"
                @end="dragging = false"
              >
                <v-col
                  lg="4"
                  sm="6"
                  v-for="(ele, index) in list"
                  :key="ele.id"
                  class="md-position-relative"
                >
                  <v-card flat>
                    <v-img
                      :src="ele.src"
                      :lazy-src="ele.src"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                  <v-btn
                    icon
                    class="md-position-top-0 custom-v-btn"
                    @click="deleteImage(index)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </draggable>
              <v-btn
                color="amber lighten-2 "
                class="white--text"
                v-if="lectureId"
                @click="recoverImg"
                large
                width="100%"
              >
                <v-icon left>mdi-cloud-refresh</v-icon
                >{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertPhoto.undo'
                  )
                }}
              </v-btn>
            </v-row>
          </v-card>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="validate"
          :disabled="!valid || list.length == 0"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { insertLecture, updateLecture } from '@/service/course/course.js';
import { getPrivateImage } from '@/service/upload/upload.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import warnningComponent from '../../../components/warningAlert.vue';
import axios from 'axios';
import { EventBus } from '../../../event-bus';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {
    warnningComponent,
  },
  data() {
    return {
      valid: true,
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertPhoto.pleaseFillName'
          ),
      ],
      enabled: true,
      ready: false,

      title: '',
      description: '',

      list: [],
      dragging: false,
      imageFiles: [],
      imageUploadId: [],

      // Edit
      oldFileId: [],
      oldFileUrl: [],

      //warnning
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
      oldList: [],

      imgPreview: [],
    };
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule =
          this.list.length > 0 ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertPhoto.chooseFile'
          );
        // const rule =
        //   this.imageUploadId.length > 0 ||
        //   this.$vuetify.lang.t(
        //     "$vuetify.courseManagement.lectureStep.insertPhoto.chooseFile"
        //   );

        rules.push(rule);
      }

      if (this.lectureId !== undefined) {
        const rule =
          this.list.length > 0 ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertPhoto.chooseFile'
          );
        // const rule =
        //   this.imageUploadId.length > 0 ||
        //   this.$vuetify.lang.t(
        //     "$vuetify.courseManagement.lectureStep.insertPhoto.chooseFile"
        //   );
        rules.push(rule);
      }

      return rules;
    },
  },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   for (let i = 0; i < filterLecture.image.length; i++) {
    //     await this.imageUploadId.push(filterLecture.image[i]._id);
    //     await this.list.push({
    //       src: await getPrivateImage(filterLecture.image[i]._id)
    //     });
    //   }

    //   this.oldFileId = [...this.imageUploadId];
    //   this.oldFileUrl = [...this.list];

    //   this.successUpload = true;
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.oldValue = filterLecture;
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          this.imageUploadId = [];
          this.list = [];
          this.ready = false;
          for (let i = 0; i < filterLecture.image.length; i++) {
            await this.imageUploadId.push(filterLecture.image[i]._id);
            await this.list.push({
              src: await getPrivateImage(filterLecture.image[i]._id),
            });
            await this.oldList.push({
              src: await getPrivateImage(filterLecture.image[i]._id),
            });
          }
          this.ready = true;

          this.imageFiles = [];
          this.oldFileId = [...this.imageUploadId];
          this.oldFileUrl = [...this.list];
          this.successUpload = true;
        } else {
          this.title = '';
          this.description = '';
          this.list = [];
          this.oldList = [];
          this.oldValue = [];
          this.dragging = false;
          this.imageFiles = [];
          this.imageUploadId = [];

          // Edit
          this.oldFileId = [];
          this.oldFileUrl = [];
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        }
      }
    },
  },
  methods: {
    async validate() {
      let totalFiles = this.list.length;
      for (var i = 0; i < totalFiles; i++) {
        if (this.list[i].file) {
          await this.uploadFile(this.list[i].file);
        }
      }

      this.warnningToSaveDialog = false;
      if (
        this.$refs.form.validate() &&
        this.successUpload &&
        this.imageUploadId.length > 0
      ) {
        if (!this.lectureId) {
          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            type: 'IMG',
            image: this.imageUploadId,
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();
          EventBus.$emit('creditPoint.show');
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            type: 'IMG',
            image: this.imageUploadId,
          });
        }
        this.clearAndCloseLectureDialog();
      }
    },
    async clearAndCloseLectureDialog() {
      if (!this.lectureId) {
        this.title = '';
        this.description = '';
        this.list = [];
        this.dragging = false;
        this.imageFiles = [];
        this.imageUploadId = [];
        this.oldFileId = [];
        this.oldFileUrl = [];
        this.$refs.form.reset();
        this.oldList = [];
        this.oldValue = [];
      }
      await this.closeLectureDialog();
    },
    async onFileChange(files) {
      files = files.target.files;
      this.successUpload = false;
      let totalFiles;
      totalFiles = files.length;
      let resultImg;
      if (this.list.length + totalFiles > 20) {
        resultImg = 20 - this.list.length;
        this.warnnig(
          `คุณสามารถอัพโหลดรูปภาพได้อีก ${resultImg} รูปเท่านั้น กรุณาเลือกรูปใหม่อีกครั้ง`,
          'warning'
        );
        this.successUpload = true;
        this.imageFiles = [];
        return;
      }
      if (totalFiles === 0) {
        this.successUpload = true;
        return;
      } else {
        for (var i = 0; i < totalFiles; i++) {
          this.list.push({
            src: await URL.createObjectURL(files[i]),
            file: files[i],
          });
          // await this.uploadFile(files[i]);
        }
        this.successUpload = true;
        this.imageFiles = [];
      }
    },
    async recoverImg() {
      this.imageUploadId = [...this.oldFileId];
      this.list = [...this.oldFileUrl];
    },
    async clearInputFileForm() {
      if (this.lectureId) {
        this.imageUploadId = [...this.oldFileId];
        this.list = [...this.oldFileUrl];
        this.successUpload = true;
      } else {
        this.imageUploadId = [];
        this.list = [];
      }
    },
    async uploadFile(file) {
      let formData = new FormData();
      /*
        Add the form data we need to submit
      */
      formData.append('fileupload', file);
      formData.append('title', file.name);
      /*
        Make the request to the POST /single-file URL
      */

      await axios
        .post(`${domain}/uploadfile/private/image/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
        })
        .then(
          async function (response) {
            await this.imageUploadId.push(response.data.result);
            // await this.oldFileId.push(response.data.result);

            // let imgUrl = await getPrivateImage(response.data.result);
            // await this.list.push({ src: imgUrl });

            // await this.oldFileUrl.push({ src: imgUrl });
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);

          let msg = 'Can not upload image';
          if (e.response != null && e.response.data != null) {
            msg = e.response.data.message;
          }

          EventBus.$emit('snackbar', {
            text: msg,
            dark: true,
            centered: true,
            color: 'error',
          });
        });
    },

    checkMove: function (e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    deleteImage(index) {
      this.list.splice(index, 1);
      this.imageUploadId.splice(index, 1);
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 7000);
    },
    checkToSave() {
      if (this.lectureId) {
        if (this.ready) {
          // this.uploadFile();
          this.imageUploadId.sort();
          this.oldFileId.sort();

          this.title !== this.oldValue.title ||
          this.description !== this.oldValue.description ||
          JSON.stringify(this.imageUploadId) !== JSON.stringify(this.oldFileId)
            ? (this.warnningToSaveDialog = true)
            : this.clearAndCloseLectureDialog();
        } else {
          this.clearAndCloseLectureDialog();
        }
      } else {
        this.title !== '' || this.description !== '' || this.list.length !== 0
          ? (this.warnningToSaveDialog = true)
          : this.clearAndCloseLectureDialog();
      }
    },
    // async preview(event) {
    //   let file = {};
    //   if (event.target.files[0]) {
    //     file = event.target.files[0];
    //     this.imageFile = file;
    //     this.tempFile = this.imageFile;
    //     this.imgPreview = await URL.createObjectURL(file);
    //     this.imageName = file.name;
    //   } else {
    //     this.imageFile = this.tempFile;
    //   }

    //   if (this.imgPreview) {
    //     this.imgBool = true;
    //     this.imageReady = true;
    //   } else {
    //     this.imageReady = false;
    //   }
    // },
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.v-input.input-image-custom {
  font-size: 14px;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.textField {
  width: 100%;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.list-group {
  width: 100%;
  flex-flow: inherit;
  min-height: 300px;
}
.md-position-relative {
  position: relative !important;
}
.md-position-top-0 {
  position: absolute;
  top: 0px;
  right: 0px;
  background: #eeeeee;
}
.custom-v-btn {
  height: 25px;
  width: 25px;
}
.custom-v-btn .v-icon {
  height: 15px;
  font-size: 15px;
  width: 15px;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
</style>
